import { createContext } from 'react';

/** Custom-attribute keys a host has fixed: their filter rows render read-only and cannot be removed. */
export const AudienceLockedAttributesContext = createContext<string[]>([]);

/** True while the form runs inside a host (the Orbit builder modal) rather than on its own page. */
export const AudienceEmbeddedContext = createContext(false);
